<template>
  <b-container id="main-container" fluid style>
    <b-row style="width:100%; background-color:#E8E8EA" align-h="center">
      <b-col class cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width:100%; margin-top:60px;" class="min-height-about" align-h="center">
      <b-col cols="12" style="max-width:1200px; padding-left:0; padding-right:0">
        <b-row class="pt-5">
          <b-col md="4" style="font-size:48px;" class='center-align-small'>Contact Us</b-col>
          <b-col>
            <b-row>
              <b-col
                class="pl-0 pr-0 center-align-small" style='font-size:16px;'
              >Get in touch and let us know how we can help - whether you have a question, a suggestion or would like to work together with us. Thank you for being a valued customer of Truthbrush. </b-col>
            </b-row>
            
          </b-col>
        </b-row>
        <b-row class="pt-5">
              <b-col md="4" class="no-h-padding-small ">
                <b-row style="height:100%">
                  <b-col style="background-color:#f5f6f9; border-radius:10px; min-height:140px;">
                    <p class="pt-3 no-h-padding-small" style="padding-left:1rem; color:#3b3a40; font-size:18px">Via Chat</p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem; color:#64626a"><b>Please click on the blue icon at bottom right</b> </p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem; color:#64626a"><b>Typical response time:</b> instant to 30 mins </p>
                    <p class="no-h-padding-small" style="padding-left:1rem; color:#64626a"><b>Service window:</b> 9 am to 5 pm, ET, M-F</p>
                    
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="4" class="no-h-padding-small padding-top-767">
                <b-row style="height:100%">
                  <b-col style="background-color:#f5f6f9; border-radius:10px; min-height:140px;">
                    <p class="pt-3 no-h-padding-small" style="padding-left:1rem; color:#3b3a40; font-size:18px">Via Email</p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem; color:#64626a"><b>Email:</b> support@truthbrush.com</p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem; color:#64626a"><b>Typical response time:</b> within 24 hours </p>
                    <p class="no-h-padding-small" style="padding-left:1rem; color:#64626a"><b>Service window:</b> 9 am to 9 pm, ET, M-F</p>
                    
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="4" class="no-h-padding-small padding-top-767 ">
                <b-row style="height:100%">
                  <b-col style="background-color:#f5f6f9; border-radius:10px; min-height:140px;">
                    <p class="pt-3 no-h-padding-small" style="padding-left:1rem;color:#3b3a40; font-size:18px">Address</p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem;color:#64626a">Wannalancit Business Center</p>
                    <p class="no-h-padding-small mb-1" style="padding-left:1rem;color:#64626a">600 Suffolk Street, Suite 250,</p>
                    <p class="no-h-padding-small" style="padding-left:1rem;color:#64626a">Lowell, MA, United States 01854</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
        <b-row>
            <b-col cols="12" class="pt-3 hide-when-small">
              <hr style="width:100%;  border: 0.5px solid #e8e7e8" />
            </b-col>
          </b-row>
        <b-row class='pb-5 modest-padding-top-small' style='padding-top:1rem'>
          <b-col cols='12'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1467.2867355600142!2d-71.31724100343172!3d42.64920146446263!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc64ab9b2b7030082!2sCandibell%20Inc.!5e0!3m2!1sen!2sus!4v1594595362549!5m2!1sen!2sus" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row style="width:100%;">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Contact",
  components: {
    NavHeader,
    NavFooter
  },
   data() {
    return {
      markers: [{
        position: {lat:42.6493455, lng:-71.3183595},
        title: '123'
      }],
    }
   }
};
</script>

<style lang="scss">
@media (max-width: 768px) {
  .padding-top-767 {
    padding-top: 25px !important;
  }
  .hide-when-small {
    display: none;
  }
  .center-align-small{
    text-align: center;
  }
}

.min-height-about {
  min-height: calc(100vh - 229px);
}


</style>